'use es6';

import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const BusContext = /*#__PURE__*/createContext({
  bus: undefined
});
export function BusProvider({
  bus,
  children
}) {
  return /*#__PURE__*/_jsx(BusContext.Provider, {
    value: {
      bus
    },
    children: children
  });
}
export function useBus() {
  const {
    bus
  } = useContext(BusContext);
  if (!bus) {
    throw new Error('Bus is undefined in BusContext. Pass a value via BusContextProvider.');
  }
  return bus;
}